"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.infoWidget = infoWidget;
var _constants = require("../../../constants/constants");
var _utils = require("../../../utils/utils");
function generateInfoUrl() {
  return (0, _utils.generateUrlWithParams)(_constants.WIDGET_ENDPOINTS.INFO, {});
}
function infoWidget(id, cssClass) {
  return (0, _utils.generateIframe)(id, cssClass, generateInfoUrl());
}
//# sourceMappingURL=bwa-info.js.map
